/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesFieldSets.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Field Set Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 02:58:19 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const FieldSetList = Loadable({
    loader: () => import('../containers/FieldSets/FieldSetListContainer'),
    loading: Loading,
});

export const FieldSetForm = Loadable({
    loader: () => import('../containers/FieldSets/FieldSetEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesFieldSets.js